<script>
import widgetWrapperScpm from '@/components/scpm/widgets/common/widgetWrapperScpm';
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetCustomScpm',
  components: {widgetWrapperScpm},
  emits: ['more'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, dateItem, more, info, empty} = items;
    const legoIcon = resolveComponent('lego-icon')
    const cLabel = resolveComponent('c-label')
    const widgetWrapperScpm = resolveComponent('widget-wrapper-scpm')

    const widgetCustom = h('div', {class: 'widget-custom'}, [this.$slots.wbody()]);
    const nullWidget = h('div', {class: 'widget-null'}, [
      h(legoIcon, {
        iconType: 'df',
        icon: 'exclamation_circle',
        size: 32,
        color: '#bbbdc1',
      }),
      h(
          cLabel,
          {
            size: 13,
            weight: 500,
            color: '#bbbdc1',
          },
          () => ['구성요소가 없습니다.'],
      ),
    ]);
    return h(
        widgetWrapperScpm,
        {
          title, subtitle, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [empty ? nullWidget : widgetCustom],
    );
  },
  methods: {},
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-custom {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  white-space: pre;
  @include font(14px);
}

.widget-null {
  padding: 31px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;

  :deep.lego-icon {
    margin-bottom: 17px;
  }
}
</style>
